import greenTrue from "../../assets/images/green-true.svg";
import greyTrue from "../../assets/images/grey-true.svg";

const OrderStatus = ({ currentStatus, is_in_kitchen }) => {
  // Define the status steps
  const steps = [
    {
      id: 1,
      name: "الطلب معلق",
      description: "في انتظار قبول الشيف للطلب لبدء التجهيز",
    },
    {
      id: 2,
      name: "جاري تحضير الطلب",
      description: "تم قبول طلبك من الشيف و جاري التحضير",
    },
    {
      id: 4,
      name: "تم التجهيز",
      description: "أنهي الشيف تحضير طلبك وسيتم توصيله الي الطاولة قريبا",
    },
    {
      id: 3,
      name: "طلبك على طاولتك",
      description: "طلبك على طاولتك و نتمنى ان تشاركنا تجربتك حول المطعم",
    },
  ];

  // نحسب آخر خطوة مكتملة حسب currentStatus.id
  const completedSteps =
    currentStatus?.id === 10
      ? 1
      : currentStatus?.id === 11
        ? 2
        : currentStatus?.id === 12
          ? 3
          : 0;

  return (
    <>
      <div className="order-status-header">حالة الطلب</div>
      <div className="order-status-container">
        {steps.map((step, index) => (
          <div key={step.id} className="order-step">
            <div className="step-icon">
              <img
                src={
                  step.id === 4
                    ? is_in_kitchen
                      ? greyTrue
                      : greenTrue
                    : step.id <= completedSteps
                      ? greenTrue
                      : greyTrue
                }
                alt={
                  step.id === 4
                    ? is_in_kitchen
                      ? "in-kitchen"
                      : "ready"
                    : step.id <= completedSteps
                      ? "active-true"
                      : "not-active-true"
                }
              />
              {index !== steps.length - 1 && (
                <div className="dashed-line"></div>
              )}
            </div>

            <div className="step-content">
              <h3>{step.name}</h3>
              <p>{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default OrderStatus;
